export default __webpack_public_path__ + "static/media/element_48.65c8a5bf.webp";